/**
 * Severity for a notification row.
 *
 * Kept out of the component file so both the row and the Inbox can import it
 * without breaking fast refresh (a component module must export only components).
 */
import type { Notification } from '../../types';

export type Severity = 'critical' | 'high' | 'normal';

/** Error alerts and URGENT both read as critical; HIGH is its own step. */
export const severityOf = (n: Notification): Severity => {
  if (n.triggerType === 'error' || n.priority === 'URGENT') return 'critical';
  if (n.priority === 'HIGH') return 'high';
  return 'normal';
};
